// src/components/common/Input.jsx
export const Input = ({ 
  label, 
  error, 
  icon,
  fullWidth = true,
  ...props 
}) => {
  const containerStyle = {
    marginBottom: "20px",
    width: fullWidth ? "100%" : "auto"
  };

  const labelStyle = {
    display: "block",
    fontSize: "14px",
    fontWeight: "600",
    color: "#334155",
    marginBottom: "8px"
  };

  const inputWrapperStyle = {
    position: "relative",
    display: "flex",
    alignItems: "center"
  };

  const iconStyle = {
    position: "absolute",
    left: "12px",
    color: "#94a3b8",
    fontSize: "18px",
    pointerEvents: "none"
  };

  const inputStyle = {
    width: "100%",
    padding: icon ? "12px 12px 12px 40px" : "12px 16px",
    fontSize: "16px",
    border: `2px solid ${error ? "#ef4444" : "#e2e8f0"}`,
    borderRadius: "8px",
    outline: "none",
    transition: "all 0.2s ease",
    backgroundColor: "#ffffff",
    fontFamily: "inherit",
    boxSizing: "border-box"
  };

  const errorStyle = {
    marginTop: "6px",
    fontSize: "14px",
    color: "#ef4444"
  };

  return (
    <div style={containerStyle}>
      {label && <label style={labelStyle}>{label}</label>}
      <div style={inputWrapperStyle}>
        {icon && <span style={iconStyle}>{icon}</span>}
        <input
          style={inputStyle}
          onFocus={(e) => {
            e.target.style.borderColor = error ? "#ef4444" : "#00a680";
            e.target.style.boxShadow = `0 0 0 3px ${error ? "rgba(239, 68, 68, 0.1)" : "rgba(0, 166, 128, 0.1)"}`;
          }}
          onBlur={(e) => {
            e.target.style.borderColor = error ? "#ef4444" : "#e2e8f0";
            e.target.style.boxShadow = "none";
          }}
          {...props}
        />
      </div>
      {error && <p style={errorStyle}>{error}</p>}
    </div>
  );
};